import { connectRefinementList } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'
import { RefinementListProvided } from 'react-instantsearch-core'
import { ComponentChildren } from 'preact'
import { RefinedTypesContent } from './RefinedTypesContent'

type SourceType =
  | 'freshdesk'
  | 'community'
  | 'knowledge_base'
  | 'zendesk'
  | 'salesforce'
  | 'skilljar'

export interface SourceTypeProps extends RefinementListProvided {
  title: ComponentChildren
}

const labelMapping: Record<SourceType, JSX.Element> = {
  community: <Phrase m='Forum' p='nav.title.community' />,
  knowledge_base: <Phrase m='Common' p='advanced.search.filter.knowledgebase.category' />,
  zendesk: <Phrase m='Forum' p='federated.search.zendesk' />,
  salesforce: <Phrase m='Forum' p='federated.search.salesforce' />,
  skilljar: <Phrase m='Forum' p='federated.search.skilljar' />,
  freshdesk: <Phrase m='Forum' p='federated.search.freshdesk' />
}

const extractLabel = (key: string) => {
  if (key in labelMapping) {
    return labelMapping[key as SourceType]
  }
  return key
}

const SourceTypesList = ({ title, ...restProps }: SourceTypeProps) => {
  return (
    <div className='instant-search__source-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      <RefinedTypesContent labelExtractor={extractLabel} {...restProps} />
    </div>
  )
}

export default connectRefinementList(SourceTypesList)
